export default "__VITE_ASSET__5e461d64__"